import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import {
  GetFirstMostSevereAndLatestDetectionsByEntityNameQuery,
  GetFirstMostSevereAndLatestDetectionsByEntityNameQueryVariables,
} from '@investigator/shared/generated/graphql';

export const GET_FIRST_MOST_SEVERE_AND_LATEST_DETECTIONS_BY_ENTITY_NAME = gql`
  query getFirstMostSevereAndLatestDetectionsByEntityName(
    $entity_name: String!
    $start: Float
    $end: Float
    $tenant: String
  ) {
    getFirstMostSevereAndLatestDetectionsByEntityName(
      entity_name: $entity_name
      start: $start
      end: $end
      tenant: $tenant
    ) {
      entity_name
      tenant
      total_detections
      detection_counts_by_severity_level {
        low
        medium
        high
      }
      detection_counts_by_mitre_tactics {
        mitre_tactic
        detection_count
      }
      detection_counts_by_status {
        open
        closed
      }
      most_severe_alert_categories
      number_of_most_severe_alert_categories
      first_detection {
        alert_info {
          alert_name
          content_id
        }
        rank {
          severity
          is_custom_severity
        }
        earliest_start_timestamp
      }
      most_recent_detection {
        alert_info {
          alert_name
          content_id
        }
        rank {
          severity
          is_custom_severity
        }
        latest_start_timestamp
      }
      most_severe_detection {
        alert_info {
          alert_name
          content_id
        }
        rank {
          severity
          is_custom_severity
        }
        latest_start_timestamp
      }
    }
  }
`;

export const useGetFirstMostSevereAndLatestDetectionsByEntityName = (
  options: QueryHookOptions<
    GetFirstMostSevereAndLatestDetectionsByEntityNameQuery,
    GetFirstMostSevereAndLatestDetectionsByEntityNameQueryVariables
  >,
) =>
  useQuery<
    GetFirstMostSevereAndLatestDetectionsByEntityNameQuery,
    GetFirstMostSevereAndLatestDetectionsByEntityNameQueryVariables
  >(GET_FIRST_MOST_SEVERE_AND_LATEST_DETECTIONS_BY_ENTITY_NAME, options);
